import AnimatedNumber from "react-animated-numbers";

const WarStat = ({number, word}) => {
	return (
		<div className="stat-genocide-war">
			<AnimatedNumber
				includeComma
				transitions={(index) => ({
					type: "tween",
					duration: index + 2,
				})}
				animateToNumber={number}
				className={"stat"}
			/>
			<span className="stat-name">{word}</span>
		</div>
	);
}

export default WarStat;